module.exports = __webpack_public_path__ + "media/images/pillar_supply-chain-4af4444e7a09ff6309f92e520893b611.jpg";